type ScrollBoxOptions = {
  selector?: string;
  startClass?: string;
  endClass?: string;
};

export function initScrollBoxes({
  selector = '.js-box-scroll',
  startClass = 'start-scroll',
  endClass = 'end-scroll'
}: ScrollBoxOptions = {}): void {
  const elements = document.querySelectorAll<HTMLElement>(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    const hasVerticalScroll = el.scrollHeight > el.clientHeight;
    const hasHorizontalScroll = el.scrollWidth > el.clientWidth;

    if (!hasVerticalScroll && !hasHorizontalScroll) return;

    const updateState = (): void => {
      let isStart = false;
      let isEnd = false;

      // вертикаль
      if (hasVerticalScroll) {
        if (el.scrollTop <= 0) isStart = true;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight) isEnd = true;
      }

      // горизонталь
      if (hasHorizontalScroll) {
        if (el.scrollLeft <= 0) isStart = true;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth) isEnd = true;
      }

      el.classList.toggle(startClass, isStart);
      el.classList.toggle(endClass, isEnd);
    };

    updateState();
    el.addEventListener('scroll', updateState, { passive: true });
  });
}